<template>
    <div id="exit">
        <img id="raio" :src="$url + 'img/raio_sair.png'">
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Sair</h3>
                <span><a href="#" v-on:click="exit"><img :src="$url + 'img/fechar.png'"></a></span>
                <div id="text">Tem certeza que gostaria<br>de sair do jogo?</div>
                <ul>
                    <li v-on:click="exit"><img class="rot" :src="$url + 'img/sim_icon.png'"><a class="btn-01" href="#"><img :src="$url + 'img/nao.png'"></a></li>
                    <li v-on:click="yes"><a class="btn-01" href="#">Sim</a><img :src="$url + 'img/sim_icon.png'"></li>
                </ul>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
        name: "ExitComponent",
        data() {
            return {
                show: false
            }
        },
        methods: {
            yes() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.view_exit = false;
                this.$parent.exit();
            },
            exit() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.view_exit = false;
            },
            keyUpEventHandler(e) {
                if (e.key == "Escape") {
                    this.exit();
                }
            }
        },
        mounted() {
            this.show = true;

            window.addEventListener('keyup', this.keyUpEventHandler);
        }
    }
</script>
<style scoped>
    #exit {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 8;
    }
    #raio
    {
        height: 383px;
        left: calc(50% - 220px);
        position: absolute;
        top: calc(50% - 192px);
        width: 439px;
    }
    #box
    {
        background-color: #fff;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: 180px;
        left: calc(50% - 250px);
        padding: 10px;
        position: absolute;
        text-align: center;
        top: calc(50% - 110px);
        width: 500px;
    }
    #box > ul
    {
        display: block;
        left: 0;
        position: absolute;
        top: 190px;
        width: 100%;
    }
    #box > ul > li
    {
        display: inline-block;
        list-style: none;
        vertical-align: top;
        text-align: center;
        width: 35%;
    }
    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: -30px auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }
    #text
    {
        font-size: 20px;
        margin-top: 70px;
    }

    .btn-01
    {
        background-color: #fff;
        border-radius: 37px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, .2);
        box-sizing: border-box;
        color: #9dca26 !important;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 60px;
        height: 58px;
        line-height: 34px;
        padding: 12px 15px;
        text-align: center;
        width: 90%;
    }
    .btn-01 > a
    {
        position: absolute;
    }
    #box > ul > li > img
    {
        background-color: #9dca26;
        border-radius: 50%;
        border-bottom: solid 2px rgba(0, 0, 0, .4);
        box-shadow: 0 5px 5px rgba(0, 0, 0, .1), 0 -1px 0 rgba(255, 255, 255, 1);
        box-sizing: border-box;
        margin-left:-20px;
        margin-top: 10px;
        padding: 10px;
        position: absolute;
        width: 40px;
    }
    .rot
    {
        transform: rotate(180deg);
    }
    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 110px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }



    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }
</style>